import { gql } from "@apollo/client";

export const CREATE_CONEXION = gql`
mutation CreateConexion(
    $idEvaluacion: Int!
    $fechaConexion: CustomDateTime!
) {
    createConexion(
        input: {
            idEvaluacion: $idEvaluacion,
            fechaConexion: $fechaConexion
        }
    )
    {
        success
        error
    }
}
`;